import { Container, Grid, Typography, Box, Paper } from '@mui/material';
import navyAwardPicture from "../images/navy_award_pic.png";

export default function About() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src={navyAwardPicture}
              alt="Kaylee in Navy uniform"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)'
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                backgroundColor: 'rgba(255, 255, 255, 0.03)',
                borderRadius: 2,
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(114, 239, 221, 0.08)',
              }}
            >
              <Typography
                variant="h3"
                component="h2"
                sx={{
                  mb: 1,
                  fontWeight: 'bold',
                  background: 'linear-gradient(45deg, #72efdd, #7E4DE2)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                About Me
              </Typography>

              <Typography
                variant="h6"
                component="p"
                sx={{
                  mb: 3,
                  color: '#72efdd',
                  fontWeight: 500,
                }}
              >
                Navy Veteran turned Software Engineer
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.85)',
                  fontSize: '1.05rem',
                  mb: 2,
                  lineHeight: 1.8,
                }}
              >
                I started my journey as a creative, but it was during my time in the Navy that I discovered a love for hands-on problem-solving and technical troubleshooting. After separating, I found the perfect blend of both worlds in programming. Since then, I've worked with a variety of languages and frameworks, and I'm just as excited to keep learning and building today as I was when I wrote my first line of code.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.85)',
                  fontSize: '1.05rem',
                  mb: 2,
                  lineHeight: 1.8,
                }}
              >
                When I'm not coding, you'll usually find me exploring new places, hiking a remote trail, or getting hooked on a new game before I've even finished the last one. I'm always seeking new challenges and staying curious—life's too short not to. Whether I'm debugging code or learning something completely new, I try to make the most of every opportunity.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.85)',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                }}
              >
                I also love connecting with passionate, like-minded people, so if that sounds like you, let's connect!
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
